<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <div class="label-pic is-red">
        <icon
          v-if="!sprintContent.sprint.continuousSprint"
          data="@icon/scrumHaltSprint.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
        <icon
          v-else
          data="@icon/continuousHaltSprint.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        class="is-flex"
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        <NotificationSprintHeader :sprint="sprintContent" />
        <span
          :style="{ color: `var(--${haltedColor})` }"
          class="sprint-sequence-number"
        >
          Halted
        </span>
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__desc"
      >
        {{ sprintContent?.haltReasonSummary }}
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Getter } from "s-vuex-class"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { Notification } from "@/models/Notification"
import { Getters } from "@/store"

import NotificationSprintHeader from "../components/NotificationSprintHeader.vue"

@Options({
  name: "HALT_SPRINT_NOTIFICATION",
  components: {
    NotificationTemplate,
    NotificationSprintHeader
  }
})
export default class HALT_SPRINT_NOTIFICATION extends Vue {
  @Prop() readonly notification: Notification
  @Getter(Getters.THEME_IS_DARK) readonly isDark: boolean
  get sprintContent() {
    return this.notification.content
  }

  get haltedColor() {
    return this.isDark ? "monochrome-03" : "monochrome-06"
  }
}
</script>

<style scoped lang="scss">
.sprint-sequence-number {
  margin-left: var(--step1);
}
</style>
